"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverySubType = exports.RegistrationSubType = exports.ERequestIds = exports.ReadModuleKeys = exports.EWriteDataType = exports.EReadDataType = void 0;
var EReadDataType;
(function (EReadDataType) {
    EReadDataType[EReadDataType["Ticket"] = -2] = "Ticket";
    EReadDataType[EReadDataType["Balance"] = -1] = "Balance";
    EReadDataType[EReadDataType["UnsignedByte"] = 0] = "UnsignedByte";
    EReadDataType[EReadDataType["UTF"] = 1] = "UTF";
    EReadDataType[EReadDataType["Byte"] = 2] = "Byte";
    EReadDataType[EReadDataType["Long"] = 3] = "Long";
    EReadDataType[EReadDataType["Short"] = 4] = "Short";
    EReadDataType[EReadDataType["Int"] = 5] = "Int";
    EReadDataType[EReadDataType["Date"] = 6] = "Date";
    EReadDataType[EReadDataType["UnsignedShort"] = 7] = "UnsignedShort";
    EReadDataType[EReadDataType["UnsignedInt"] = 8] = "UnsignedInt";
})(EReadDataType || (exports.EReadDataType = EReadDataType = {}));
var EWriteDataType;
(function (EWriteDataType) {
    EWriteDataType[EWriteDataType["Byte"] = 0] = "Byte";
    EWriteDataType[EWriteDataType["UTF"] = 1] = "UTF";
    EWriteDataType[EWriteDataType["Int"] = 2] = "Int";
    EWriteDataType[EWriteDataType["Short"] = 3] = "Short";
    EWriteDataType[EWriteDataType["Long"] = 4] = "Long";
})(EWriteDataType || (exports.EWriteDataType = EWriteDataType = {}));
var ReadModuleKeys;
(function (ReadModuleKeys) {
    ReadModuleKeys["BonusPack"] = "!bp!";
    ReadModuleKeys["ReadBalance"] = "!rb!";
    ReadModuleKeys["ReadOperation"] = "!ro!";
    ReadModuleKeys["ReadTotalDeposit"] = "!rtd!";
    ReadModuleKeys["ReadTournamentInfo"] = "!rti!";
    ReadModuleKeys["ReadSlotegratorSession"] = "!rss!";
    ReadModuleKeys["ReadSlotegratorEntities"] = "!rse!";
    ReadModuleKeys["ReadLotteryTicket"] = "!rlt!";
    ReadModuleKeys["ReadPaymentResponse"] = "!rpr!";
    // TODO custom
    ReadModuleKeys["ReadCasinoCategoriesName"] = "!rccn!";
    ReadModuleKeys["ReadCasinoGameIds"] = "!rcgi!";
})(ReadModuleKeys || (exports.ReadModuleKeys = ReadModuleKeys = {}));
var ERequestIds;
(function (ERequestIds) {
    ERequestIds[ERequestIds["Unknown"] = -1] = "Unknown";
    ERequestIds[ERequestIds["BetBazarInit"] = 0] = "BetBazarInit";
    ERequestIds[ERequestIds["InitCasinoDemo"] = 1] = "InitCasinoDemo";
    ERequestIds[ERequestIds["InitCasinoGame"] = 2] = "InitCasinoGame";
    ERequestIds[ERequestIds["AuthorizeByEmail"] = 3] = "AuthorizeByEmail";
    ERequestIds[ERequestIds["AuthorizeByToken"] = 4] = "AuthorizeByToken";
    ERequestIds[ERequestIds["RequestBalance"] = 5] = "RequestBalance";
    ERequestIds[ERequestIds["GetCurrentUserTournamentPlace"] = 6] = "GetCurrentUserTournamentPlace";
    ERequestIds[ERequestIds["Registration"] = 7] = "Registration";
    ERequestIds[ERequestIds["GetPhoneCode"] = 8] = "GetPhoneCode";
    ERequestIds[ERequestIds["UpdatePassword"] = 9] = "UpdatePassword";
    ERequestIds[ERequestIds["RecoveryPasswordResponse"] = 10] = "RecoveryPasswordResponse";
    ERequestIds[ERequestIds["RecoveryPasswordSendCode"] = 11] = "RecoveryPasswordSendCode";
    ERequestIds[ERequestIds["SetNewPassword"] = 12] = "SetNewPassword";
    ERequestIds[ERequestIds["UpdateUserPhone"] = 13] = "UpdateUserPhone";
    ERequestIds[ERequestIds["UpdateUserEmail"] = 14] = "UpdateUserEmail";
    ERequestIds[ERequestIds["FrameLoyaltyBonus"] = 15] = "FrameLoyaltyBonus";
    // Deposits
    ERequestIds[ERequestIds["RequestDeposit"] = 16] = "RequestDeposit";
    ERequestIds[ERequestIds["AnindaHavaleRequest"] = 17] = "AnindaHavaleRequest";
    // Important FOR deeplinks
    ERequestIds[ERequestIds["GoogleInrDeposit"] = 18] = "GoogleInrDeposit";
    ERequestIds[ERequestIds["DepositPhonePe"] = 19] = "DepositPhonePe";
    ERequestIds[ERequestIds["DepositPayTm"] = 20] = "DepositPayTm";
    // withdraw IMPS
    ERequestIds[ERequestIds["INRWithdrawImp"] = 21] = "INRWithdrawImp";
    // Cripto
    ERequestIds[ERequestIds["DepositTRC"] = 22] = "DepositTRC";
    ERequestIds[ERequestIds["DepositERC"] = 23] = "DepositERC";
    ERequestIds[ERequestIds["DepositBEP"] = 24] = "DepositBEP";
    ERequestIds[ERequestIds["DepositQrForm"] = 25] = "DepositQrForm";
    ERequestIds[ERequestIds["WithdrawCoinPay"] = 26] = "WithdrawCoinPay";
    // Billing
    ERequestIds[ERequestIds["GetBillingAddress"] = 27] = "GetBillingAddress";
    // Withdraw
    ERequestIds[ERequestIds["WithdrawRubles"] = 28] = "WithdrawRubles";
    ERequestIds[ERequestIds["BKashWithdraw"] = 29] = "BKashWithdraw";
    ERequestIds[ERequestIds["CriptoWithdraw"] = 30] = "CriptoWithdraw";
    ERequestIds[ERequestIds["WithdrawBank"] = 31] = "WithdrawBank";
    ERequestIds[ERequestIds["WithdrawPix"] = 32] = "WithdrawPix";
    ERequestIds[ERequestIds["PixPagsmileWithdraw"] = 33] = "PixPagsmileWithdraw";
    ERequestIds[ERequestIds["PixBankTransferWithdraw"] = 34] = "PixBankTransferWithdraw";
    // Widthdray turkish
    ERequestIds[ERequestIds["WithdrawPapara"] = 35] = "WithdrawPapara";
    ERequestIds[ERequestIds["WithdrawAninda"] = 36] = "WithdrawAninda";
    ERequestIds[ERequestIds["WithdrawMPayFix"] = 37] = "WithdrawMPayFix";
    ERequestIds[ERequestIds["MPayWithdraw"] = 38] = "MPayWithdraw";
    // End withdraw turkish
    // Withdraw Monetics
    ERequestIds[ERequestIds["WithdrawMonetics"] = 39] = "WithdrawMonetics";
    ERequestIds[ERequestIds["WithdrawHavaleHera"] = 40] = "WithdrawHavaleHera";
    // Wellex pay
    ERequestIds[ERequestIds["WithdrawWellexPay"] = 41] = "WithdrawWellexPay";
    // MNX
    ERequestIds[ERequestIds["MNXWallet"] = 42] = "MNXWallet";
    // END
    // Fav
    ERequestIds[ERequestIds["SaveToFav"] = 43] = "SaveToFav";
    // operation
    ERequestIds[ERequestIds["CancelOperation"] = 44] = "CancelOperation";
    ERequestIds[ERequestIds["ApplyBonusPack"] = 45] = "ApplyBonusPack";
    // lotteries
    ERequestIds[ERequestIds["BuyTickets"] = 46] = "BuyTickets";
    ERequestIds[ERequestIds["LotteryHistoryTicket"] = 47] = "LotteryHistoryTicket";
    // lib
    ERequestIds[ERequestIds["GetCasinoOperations"] = 48] = "GetCasinoOperations";
    ERequestIds[ERequestIds["GetDepositOperations"] = 49] = "GetDepositOperations";
    ERequestIds[ERequestIds["CasinoTournaments"] = 50] = "CasinoTournaments";
    ERequestIds[ERequestIds["ExtraLines"] = 51] = "ExtraLines";
    ERequestIds[ERequestIds["CashOut"] = 52] = "CashOut";
    ERequestIds[ERequestIds["RequestTickets"] = 53] = "RequestTickets";
    ERequestIds[ERequestIds["LastWinners"] = 54] = "LastWinners";
    ERequestIds[ERequestIds["RequestLotteries"] = 55] = "RequestLotteries";
    ERequestIds[ERequestIds["ReferralWithdraw"] = 56] = "ReferralWithdraw";
    ERequestIds[ERequestIds["WalletAzn"] = 57] = "WalletAzn";
})(ERequestIds || (exports.ERequestIds = ERequestIds = {}));
// REGISTRATION SUB ID
var RegistrationSubType;
(function (RegistrationSubType) {
    RegistrationSubType[RegistrationSubType["UpdateUserInfo"] = 6] = "UpdateUserInfo";
    RegistrationSubType[RegistrationSubType["Email"] = 16] = "Email";
    RegistrationSubType[RegistrationSubType["Phone"] = 17] = "Phone";
    RegistrationSubType[RegistrationSubType["OneClick"] = 19] = "OneClick";
    RegistrationSubType[RegistrationSubType["PromoEmail"] = 26] = "PromoEmail";
    RegistrationSubType[RegistrationSubType["PhoneWithoutCode"] = 27] = "PhoneWithoutCode";
})(RegistrationSubType || (exports.RegistrationSubType = RegistrationSubType = {}));
var RecoverySubType;
(function (RecoverySubType) {
    RecoverySubType[RecoverySubType["Phone"] = 5] = "Phone";
    RecoverySubType[RecoverySubType["AssignPhoneCode"] = 8] = "AssignPhoneCode";
    RecoverySubType[RecoverySubType["Email"] = 20] = "Email";
})(RecoverySubType || (exports.RecoverySubType = RecoverySubType = {}));
